<template>
  <div :style="{background: '#e7edf5', height: '100vh', padding: '0', display: 'flex', overflow: hidden}">

    <!-- 左侧整列：一级菜单 + 二级菜单（从顶到底） -->
    <div style="display: flex; flex-shrink: 0; height: 100%;">

      <!-- 一级菜单（图标竖排，从顶部到底部）：排行(home)按序插入在"结算"之后 -->
      <div style="width: 60px; background: #e7edf5; overflow-y: auto; padding: 0 0 12px 0; flex-shrink: 0;">
        <div
          v-for="item in menuIcons"
          :key="item.key"
          style="display: flex; align-items: center; justify-content: center; cursor: pointer; transition: background 0.2s; position: relative; width: 60px; height: 48px; margin: 0 auto;"
          :style="{
            background: menuFocusKey === item.key ? '#ffffff' : 'transparent'
          }"
          @click="onIconClick(item)"
          @mouseenter="(e) => { if (menuFocusKey !== item.key) e.currentTarget.style.background = '#ffffff' }"
          @mouseleave="(e) => { if (menuFocusKey !== item.key) e.currentTarget.style.background = 'transparent' }"
        >
          <!-- 嘀盟 LOGO（最顶部标识位，点击回默认"全部客户"页） -->
          <img v-if="item.key === 'logo'" src="~@/assets/scrm-logo.png" alt="" style="width: 28px; height: 28px;">
          <!-- 排行图标（home） -->
          <svg v-else-if="item.key === 'home'" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 20V10M12 20V4M19 20v-6" stroke-width="2" :stroke="menuFocusKey === item.key ? '#1890ff' : '#666'" stroke-linecap="round"/>
          </svg>
          <img v-else-if="item.iconUrl" :src="item.iconUrl" alt="" style="width: 20px; height: 20px;">
          <!-- 分类语义图标：按分类名渲染内联 SVG，不依赖后台菜单的图标名配置，避免图标缺失/渲染差异 -->
          <svg v-else-if="categoryIcon(item.title)" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path v-for="(p, pi) in categoryIcon(item.title)" :key="pi" :d="p" :stroke="menuFocusKey === item.key ? '#1890ff' : '#666'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
          <!-- 兜底：没配语义图标的分类按后台图标名渲染（antd 内置名用 a-icon；icon-* 才用 iconfont） -->
          <a-icon v-else-if="item.icon && !item.icon.startsWith('icon-')" :type="item.icon" style="font-size: 20px;" :style="{ color: menuFocusKey === item.key ? '#1890ff' : '#666' }" />
          <icon-font v-else-if="item.icon" :type="item.icon" style="font-size: 20px;" :style="{ color: menuFocusKey === item.key ? '#1890ff' : '#666' }"></icon-font>
          <!-- 呼吸效果小圆点 -->
          <div v-if="item.hasBadge" class="badge-dot"></div>
        </div>
      </div>

      <!-- 二级菜单（文字竖排） -->
      <div style="width: 200px; background: #ffffff; overflow: hidden; flex: 1; border-bottom: 1px solid #e8e8e8;">
        <sub-sidebar-menu :menus="subMenus" :active-key="activeSubMenu" @select="onSubMenuSelect" @scroll="onMenuScroll" @delete-template="onDeleteFilterTemplate">
          <template #title>
            <div style="padding: 16px; font-size: 14px; color: #999; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; flex: 1;">
              <span>{{ subTitle }}</span>
              <span v-if="subMenuTitle && subMenuTitle !== subTitle" style="margin: 0 6px; color: #ccc;">/</span>
              <span v-if="subMenuTitle && subMenuTitle !== subTitle" style="color: #333; font-weight: 600;">{{ subMenuTitle }}</span>
            </div>
          </template>
        </sub-sidebar-menu>
      </div>

    </div>

    <!-- 右侧区域：header + 内容区 -->
    <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">

      <!-- 顶栏（不再独占整行，只在右侧区域） -->
      <div style="height: 48px; background: #ffffff; box-shadow: 0 2px 8px rgba(0,0,0,0.06); display: flex; align-items: center; padding: 0 20px 0 0; margin-bottom: 16px; justify-content: space-between; flex-shrink: 0;">
        <!-- 顶栏消息区：日期(默认) / 公告(未读上下轮播) / 喜报通知(横向滚动，出现时优先显示) -->
        <div style="flex: 0 0 320px; width: 320px; margin-left: 16px; margin-right: auto; display: flex; align-items: center; overflow: hidden;">
          <!-- 喜报通知：带胶囊背景，横向滚过即结束，滚完恢复公告/日期 -->
          <div v-if="notifyActive" class="dm-notify" @mouseenter="pauseNotify" @mouseleave="resumeNotify">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#faad14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
            <div ref="notifyRail" class="dm-notify-rail">
              <span ref="notifyText" class="dm-notify-text"><span style="margin-right: 4px;">🎉🎉🎉</span><span v-for="(s, i) in notifySegments(notifyActive)" :key="i" :style="{ color: s.hl ? '#1890ff' : '' }">{{ s.t }}</span></span>
            </div>
          </div>
          <!-- 日期态：没有未读公告 -->
          <template v-else-if="activeNotices.length === 0">
            <div style="display: flex; align-items: center; gap: 6px;">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              <span style="font-size: 13px; color: #666; white-space: nowrap;">{{ todayText }}</span>
            </div>
          </template>
          <!-- 公告态：单条向上轮播，点击单条弹窗看详情 -->
          <template v-else>
            <div class="dm-notice-viewport" @mouseenter="onTickerEnter" @mouseleave="onTickerLeave">
              <div class="dm-notice-track" :style="{ transform: 'translateY(' + (-tickerIndex * 100) + '%)', transition: tickerMoving ? 'transform .3s ease' : 'none' }">
                <div v-for="n in activeNotices" :key="n.id" class="dm-notice-line" @click="openNotice(n)">
                  <span class="dm-notice-tag">NEW</span>
                  <span class="dm-notice-title">{{ n.title }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- 个人中心 -->
        <user-menu />
      </div>

      <!-- 内容区：工具栏 + 表格 -->
      <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden; margin-left: 16px;">

        <!-- 调列宽/列排序模式专用工具栏：显示提示+保存取消 -->
        <div v-if="resizeState && toolbarMode !== 'freeze'" style="flex-shrink: 0; display: flex; align-items: center; gap: 12px; padding: 0 16px 16px 0;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1890ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
          <span style="color: #666; font-size: 14px;">{{ toolbarMode === 'sort' ? '请长按表头拖拽调整排序' : (toolbarMode === 'freeze' ? '请点击表头图标冻结列，冻结列固定在最左侧' : '请长按表格竖线拖拽调整列宽') }}</span>
          <div 
            @click="onSaveResize"
            class="dm-tb-btn dm-tb-btn-primary dm-tb-btn-wide dm-dark-exempt"
          >
            保存
          </div>
          <div 
            @click="onCancelResize"
            class="dm-tb-btn dm-tb-btn-default dm-tb-btn-wide"
          >
            取消
          </div>
        </div>

        <!-- 列冻结模式专用工具栏：提示 + 下拉选择冻结列数 + 保存取消 -->
        <div v-else-if="resizeState && toolbarMode === 'freeze'" style="flex-shrink: 0; display: flex; align-items: center; gap: 12px; padding: 0 16px 16px 0;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1890ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
          <span style="color: #666; font-size: 14px;">冻结第0列~</span>
          <div style="position: relative; display: inline-block; flex-shrink: 0;">
            <select v-model="freezeSelect" @change="onFreezeCountChange" style="height: 32px; border: 1px solid #d9d9d9; border-radius: 4px; padding: 0 22px 0 12px; font-size: 14px; color: #333; outline: none; background: #fff; appearance: none; -webkit-appearance: none; cursor: pointer;">
              <option :value="0">0</option>
              <option v-for="n in freezeMax" :key="n" :value="n">{{ n }}</option>
            </select>
            <svg width="10" height="6" viewBox="0 0 10 6" style="position: absolute; right: 6px; top: 50%; transform: translateY(-50%); pointer-events: none;">
              <path d="M1 1 L5 5 L9 1" fill="none" stroke="#999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span style="color: #666; font-size: 14px;">列</span>
          <div 
            @click="onSaveResize"
            class="dm-tb-btn dm-tb-btn-primary dm-tb-btn-wide dm-dark-exempt"
          >
            保存
          </div>
          <div 
            @click="onCancelResize"
            class="dm-tb-btn dm-tb-btn-default dm-tb-btn-wide"
          >
            取消
          </div>
        </div>

        <!-- 工具栏（右上：操作按钮，有按钮时才显示） -->
        <div v-else-if="toolbarButtons.length > 0" style="flex-shrink: 0; display: flex; align-items: center; gap: 12px; padding: 0 16px 16px 0;">
          <template v-for="btn in toolbarButtons">
            <!-- 所有按钮统一样式：高度 32px -->
            <div 
              :key="btn.key" 
              @click.stop="!btn.disabled && onToolbarButtonClick(btn)" 
              :class="[
                'dm-tb-btn',
                btn.type === 'primary' || btn.type === 'warning' ? 'dm-tb-btn-primary' : (btn.type === 'danger' ? 'dm-tb-btn-danger' : 'dm-tb-btn-default'),
                { 'btn-loading': btn.loading, 'dm-dark-exempt': btn.type === 'primary' || btn.type === 'warning', 'dm-tb-btn-active': btn.active, 'dm-tb-btn-disabled': btn.disabled, 'dm-tb-btn-reload': isReloadBtn(btn) }
              ]"
            >
              <!-- SVG 图标：加号 -->
              <svg v-if="btn.icon === 'user-add'" width="14" height="14" viewBox="0 0 24 24" fill="none" style="margin-right: 4px;">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/>
              </svg>
              <!-- 通用加号图标：iconfont 库里没有 'plus'，这里内置 SVG，fill 用 currentColor 跟随按钮文字色 -->
              <svg v-else-if="btn.icon === 'plus'" width="14" height="14" viewBox="0 0 24 24" fill="none" style="margin-right: 4px;">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/>
              </svg>
              <!-- 通用上传图标：iconfont 库里没有裸 'upload'，内置 SVG -->
              <svg v-else-if="btn.icon === 'upload'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="17 8 12 3 7 8"/>
                <line x1="12" y1="3" x2="12" y2="15"/>
              </svg>
              <span v-else-if="btn.icon && btn.icon.startsWith('<svg')" v-html="btn.icon" style="display: inline-flex; margin-right: 4px; vertical-align: text-bottom;"></span>
              <icon-font v-else-if="btn.icon" :type="btn.icon"></icon-font>
              <span>{{ btn.title }}</span>
            </div>
          </template>
          <!-- 常用模板按钮组：高级筛选模式且已输入筛选条件时显示 -->
          <template v-if="filterHasConditions">
            <div
              v-if="!currentMatchedTemplate"
              @click="onFilterSaveTemplate"
              class="dm-tb-btn dm-tb-btn-primary dm-dark-exempt"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
              </svg>
              设为常用模板
            </div>
            <template v-else>
              <div
                @click="onRenameTemplate"
                class="dm-tb-btn dm-tb-btn-default"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
                更改模板名
              </div>
              <div
                @click="onDeleteTemplate"
                class="dm-tb-btn dm-tb-btn-danger"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="3 6 5 6 21 6"/>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                </svg>
                删除模板
              </div>
            </template>
          </template>
        </div>

        <!-- 内容栏（右下） -->
        <div style="flex: 1; background: #ffffff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); overflow: hidden; display: flex; flex-direction: column; margin-right: 16px;">
          <!-- 首页/排行：直接渲染 RankList -->
          <rank-list v-if="activeMenu === 'home'" :rank-type="homeRankType" style="flex: 1; overflow: auto;" />
          <!-- 其他页面：路由渲染 -->
          <router-view v-else style="flex: 1; overflow: hidden; display: flex; flex-direction: column;" />
        </div>

      </div>
    </div>

    <!-- update-start---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ---- -->
    <!--<setting-drawer></setting-drawer>-->
    <!-- update-end---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ---- -->

    <!-- 顶栏公告详情弹窗 -->
    <div v-if="noticeModalVisible && currentNotice" class="dm-notice-mask" @click.self="closeNoticeModal">
      <div class="dm-notice-modal">
        <div class="dm-notice-modal-header">
          <span class="dm-notice-modal-title">{{ currentNotice.title }}</span>
          <button class="dm-notice-modal-close" @click="closeNoticeModal">×</button>
        </div>
        <div class="dm-notice-modal-body">
          <div class="dm-notice-modal-meta">
            <span class="dm-notice-modal-type" :class="currentNotice.type === '新增' ? 'new' : 'opt'">{{ currentNotice.type }}</span>
            <span class="dm-notice-modal-date">{{ currentNotice.date }}</span>
          </div>
          <div>{{ currentNotice.content }}</div>
        </div>
        <div class="dm-notice-modal-footer">
          <button class="dm-notice-modal-btn" @click="confirmNoticeRead">我知道了</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SubSidebarMenu from '@/components/menu/SubSidebarMenu'
  import GlobalHeader from '@/components/page/GlobalHeader'
  import UserMenu from '@/components/tools/UserMenu'
  import RankList from '@/views/dashboard/RankList'
  import { getAction } from '@/api/manage'
  import GlobalFooter from '@/components/page/GlobalFooter'
  import eventBus from '@/utils/eventBus'

  import warterMark from "@/components/_util/waterMark";


  // update-start---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------
  // import SettingDrawer from '@/components/setting/SettingDrawer'
  // 注释这个因为在个人设置模块已经加载了SettingDrawer页面
  // update-end ---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------

  import { triggerWindowResizeEvent } from '@/utils/util'
  import { mapState, mapActions } from 'vuex'
  import { mixin, mixinDevice } from '@/utils/mixin.js'
  import {  mapGetters } from 'vuex'

  // 二级目录角标映射（key=分类名，value=statistics 字段名）
  const SUB_BADGE_MAP = {
    '客户': {
      '今日新增': 'driverAddNum',
      '今日更新': 'driverUpdateNum'
    },
    '工单': {
      '待处理': 'workderNum',
      '挂起中': 'workderHoldNum'
    },
    '车辆': {
      '今日新增': 'carAddNum',
      '今日更新': 'carUpdateNum',
      '全量完善信息': 'carInformationNum'
    },
    '结算': {
      '待结算': 'jsNum'
    },
    '通知': {
      '未读通知': 'noticeNum'
    }
  }
  // 二级目录角标级别：gray-text=灰色数字, red-text=红色数字, red-bg=红底白字
  const SUB_BADGE_TYPE_MAP = {
    '客户': {
      '今日新增': 'gray-text',
      '今日更新': 'gray-text'
    },
    '工单': {
      '待处理': 'red-bg',
      '挂起中': 'red-text'
    },
    '车辆': {
      '今日新增': 'gray-text',
      '今日更新': 'gray-text',
      '全量完善信息': 'red-bg'
    },
    '结算': {
      '待结算': 'red-bg'
    },
    '通知': {
      '未读通知': 'red-bg'
    }
  }
  export default {
    name: 'GlobalLayout',
    components: {
      SubSidebarMenu,
      GlobalHeader,
      UserMenu,
      RankList,
      GlobalFooter,
      warterMark
      // update-start---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------
      // // SettingDrawer
      // 注释这个因为在个人设置模块已经加载了SettingDrawer页面
      // update-end ---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------

    },
    mixins: [mixin, mixinDevice],
    // 全局新增抽屉保存成功后会调 closeCurrent，这里提供为“关闭全局抽屉”
    provide() {
      return {
        closeCurrent: this.closeGlobalAddDrawers
      }
    },
    data() {
      return {
        collapsed: true,
        hidden: false,
        // 默认空：登录后路由匹配（matchRouteToSubMenu）会立即设置正确的选中态；避免菜单未返回时误渲染排行
        activeMenu: '',
        // 一级图标栏的"当前聚焦分类"：点击图标或滚动二级菜单时临时高亮（不影响内容区 activeMenu）
        menuFocusKey: '',
        // 面包屑默认"嘀盟CRM / 首页"：登录落首页/挂载瞬间即正确，切业务页后由 matchRouteToSubMenu 覆盖
        subTitle: '嘀盟CRM',
        // 面包屑二级：当前目录名（分类名/目录名）
        subMenuTitle: '首页',
        subMenus: [],
        activeSubMenu: 'rank-new',
        toolbarButtons: [], // 工具栏按钮（页面传过来）
        resizeMode: false, // 列宽调整模式开关
        resizeTick: 0, // 强制刷新调整模式状态
        resizeState: false, // 轮询得到的调整模式状态
        filterState: false, // 高级筛选模式状态（页面通过 enter/exit-filter-mode 事件控制）
        filterHasConditions: false, // 高级筛选模式下是否已输入表头筛选条件（控制「设为常用模板」按钮显隐）
        filterTemplates: {}, // 各一级菜单下已保存的筛选模板（key=一级菜单key），由筛选组件 filter-templates-loaded 事件同步
        currentMatchedTemplate: null, // 当前筛选条件匹配的已保存模板（用于工具栏显示"更改模板名"/"删除模板"）
        filterReloadLoading: false, // 筛选专用栏「重新加载」按钮的转圈反馈
        toolbarMode: 'resize', // 当前工具栏模式：resize=调列宽 sort=列排序 freeze=列冻结
        freezeMax: 0, // 冻结模式下拉最大列数（由页面进入模式时上报）
        freezeSelect: 1, // 冻结模式下拉当前选中值
        statistics: {
          workderNum: 0,
          workderHoldNum: 0,
          driverAddNum: 0,
          driverUpdateNum: 0,
          carAddNum: 0,
          carUpdateNum: 0,
          carInformationNum: 0,
          jsNum: 0,
          noticeNum: 0
        },
        menus: [],
        windowHeight:600,
        // 全局搜索栏（当前 UI 已改为「开发中」占位，接入后端搜索接口后取消注释恢复）
        // globalSearchKeyword: '',
        // searchFocused: false
        // ---- 顶栏公告（数据源待接入：以后由后端公告接口/update-log.json 提供，当前置空只显示日期） ----
        // 数据结构示例：{ id: 1, type: '新增', date: '2026-10-13', title: '...', content: '...' }
        notices: [],
        readNoticeIds: (function() {
          try { return JSON.parse(localStorage.getItem('pro__noticeRead') || '[]') } catch (e) { return [] }
        })(),
        // ---- 横向滚动喜报通知：由后端轮询接口 dmPlatformNotify/queryList 增量拉取（滚过即消失，FIFO 依次播） ----
        notifyQueue: [],
        notifyActive: null, // 当前正在横向滚动的喜报
        notifyTimer: null, // 保留字段（rAF 驱动后不再使用，占位兼容）
        _notifySeen: null, // 本次会话已播喜报 id 集合（去重，防止同一会话重复播）
        _notifyPollTimer: null, // 喜报轮询定时器
        tickerIndex: 0, // 当前轮播到第几条
        tickerMoving: false, // 轮播位移动画开关（首次/重置时不播）
        tickerTimer: null, // 轮播定时器
        currentNotice: null, // 正在查看的公告（弹窗）
        noticeModalVisible: false // 公告详情弹窗显隐
      }
    },mounted () {
      // 注意：本组件在下方 ~397 行重复定义了 mounted，按 JS 对象字面量语义此块被整体覆盖、永不执行；
      // 事件监听注册统一放在 created（与 set-toolbar-buttons 一起），需要新增监听时请去 created 注册。
      this.$nextTick(() => {
        console.log(window.innerHeight)
        this.windowHeight = window.innerHeight-108
      })
      // 启动时自动清掉所有业务页的临时调列宽状态，刷新永远回到默认常态
      localStorage.setItem('driverResizingMode', 'false')
      localStorage.setItem('carResizingMode', 'false')
      localStorage.setItem('jsResizingMode', 'false')
      localStorage.setItem('phoneResizingMode', 'false')
      localStorage.setItem('platformResizingMode', 'false')
    },
    beforeDestroy() {
      if (this.resizeTimer) clearInterval(this.resizeTimer)
      eventBus.$off('statistics-refresh', this.refreshStatistics)
      if (this.statTimer) clearInterval(this.statTimer)
      if (this.onVisChange) document.removeEventListener('visibilitychange', this.onVisChange)
      this.stopTicker()
      if (this._notifyRaf) cancelAnimationFrame(this._notifyRaf)
      if (this._notifyBusHandler) eventBus.$off('push-notify', this._notifyBusHandler)
      if (this._notifyPollTimer) clearInterval(this._notifyPollTimer)
      if (this.notifyTimer) clearTimeout(this.notifyTimer)
    },
    computed: {
      // 未读公告（已读的不再轮播）
      activeNotices() {
        return this.notices.filter(n => !this.readNoticeIds.includes(n.id))
      },
      // 当天日期文案：今天是X月X日 星期X
      todayText() {
        const w = ['日', '一', '二', '三', '四', '五', '六']
        const d = new Date()
        return '今天是' + (d.getMonth() + 1) + '月' + d.getDate() + '日 星期' + w[d.getDay()]
      },
      // 喜报横向滚动时长：已改为 data.notifyDuration 动态计算（按轨道宽+文字宽/速度），此处删除
      homeRankType() {
        if (this.activeSubMenu === 'rank-wait') return 'wait'
        if (this.activeSubMenu === 'rank-hold') return 'hold'
        if (this.activeSubMenu === 'rank-customer') return 'customer'
        return 'new'
      },
      // 是否处于列宽调整模式
      isResizeMode() {
        // 依赖resizeTick触发重新计算
        this.resizeTick
        try {
          return localStorage.getItem('driverResizingMode') === 'true' 
              || localStorage.getItem('carResizingMode') === 'true'
              || localStorage.getItem('jsResizingMode') === 'true'
              || localStorage.getItem('phoneResizingMode') === 'true'
              || localStorage.getItem('platformResizingMode') === 'true'
        } catch (e) {
          return false
        }
      },
      ...mapState({
        // 主路由
        mainRouters: state => state.permission.addRouters,
        // 后台菜单
        permissionMenuList: state => state.user.permissionList
      }),
      // 把后端菜单转换成一级菜单需要的格式
      sidebarMenus() {
        if (!this.permissionMenuList || this.permissionMenuList.length === 0) {
          return []
        }
        // 根据菜单标题判断是否有角标：只有红底白字(red-bg)级别的才触发一级菜单呼吸圆点
        const hasBadgeMap = {
          '客户': false, // 今日新增/更新都是灰底，不触发
          '工单': this.statistics.workderNum > 0, // 待处理(红底白字)才触发，挂起中不触发
          '车辆': this.statistics.carInformationNum > 0,
          '结算': this.statistics.jsNum > 0,
          '通知': this.statistics.noticeNum > 0
        }
        // permissionMenuList 本身就是一级菜单数组
        return this.permissionMenuList
          // "通知"分类暂且下线（后续重新开发），侧栏/图标栏/目录均不再展示
          .filter(item => item.meta && item.meta.title !== '首页' && item.meta.title !== '通知' && !item.hidden)
          .map(item => ({
            key: item.name || item.id,
            title: item.meta.title,
            icon: item.meta.icon || 'appstore',
            iconUrl: item.meta.iconUrl,
            hasBadge: hasBadgeMap[item.meta.title] || false,
            children: item.children || []
          }))
      },
      // 一级图标栏顺序：排行(home)图标插入到"结算"分类之后（无结算时兜底"平台"之后，再兜底最前）
      menuIcons() {
        const icons = (this.sidebarMenus || []).slice()
        const findIdx = (pred) => {
          for (let i = 0; i < icons.length; i++) {
            if (pred(icons[i])) return i
          }
          return -1
        }
        let targetIdx = findIdx(m => m.title === '结算')
        if (targetIdx < 0) {
          targetIdx = findIdx(m => m.title === '平台' || (m.key && m.key.toLowerCase().indexOf('platform') >= 0))
        }
        const homeItem = { key: 'home', title: '排行', icon: '', iconUrl: '', hasBadge: false }
        if (targetIdx >= 0) {
          icons.splice(targetIdx + 1, 0, homeItem)
        } else {
          icons.unshift(homeItem)
        }
        // 最顶部固定嘀盟 LOGO 标识位
        icons.unshift({ key: 'logo', title: '嘀盟', logo: true, hasBadge: false })
        return icons
      }
    },
    watch: {
      sidebarOpened(val) {
        this.collapsed = !val
      },
      // 只要当前匹配了模板，就自动设置filterHasConditions为true，保证工具栏按钮正确显示
      currentMatchedTemplate(newVal) {
        this.filterHasConditions = !!newVal
      },
      // 未读公告变化：重置轮播位置，>=2 条时启动轮播
      activeNotices(val) {
        this.tickerIndex = 0
        this.tickerMoving = false
        this.stopTicker()
        if (val.length >= 2) this.startTicker()
      },
      // 路由变化：重新匹配当前目录，设置一级/二级选中态与面包屑（登录跳转晚于菜单加载时的兜底）
      '$route'() {
        this.matchRouteToSubMenu()
      },
      // 后台菜单加载完成后：构建平铺目录并匹配当前路由（异步菜单晚于 mounted 时兜底）
      permissionMenuList: {
        handler() {
          if (this.permissionMenuList && this.permissionMenuList.length > 0) {
            this.buildAllSubMenus()
            this.matchRouteToSubMenu()
          }
        }
      }
    },
    created() {

      //--update-begin----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
      //this.menus = this.mainRouters.find((item) => item.path === '/').children;
      this.menus = this.permissionMenuList

      // 初始化立即匹配当前路由（首页/排行等不依赖异步菜单的路径，防止面包屑停留在默认值）
      this.matchRouteToSubMenu()

      // 初始化顶栏公告轮播（未读公告 >= 2 条时开始）
      this.$nextTick(() => {
        if (this.activeNotices.length >= 2) this.startTicker()
      })

      // 获取统计数据（二级菜单角标）
      this.loadStatistics()

      // 角标实时刷新：事件驱动（写操作成功后） + 60s 兜底定时 + 页面可见性恢复
      eventBus.$on('statistics-refresh', this.refreshStatistics)
      this.statTimer = setInterval(this.refreshStatistics, 60000)
      this.onVisChange = () => {
        if (!document.hidden) this.refreshStatistics()
      }
      document.addEventListener('visibilitychange', this.onVisChange)

      // 监听页面传过来的工具栏按钮
      eventBus.$on('set-toolbar-buttons', (buttons) => {
        this.toolbarButtons = buttons || []
      })

      // 监听进入列宽调整模式事件
      eventBus.$on('enter-resize-mode', () => {
        this.resizeMode = true
        this.resizeState = true
      })
      // 监听列冻结模式：页面上报列数与当前冻结值（初始化下拉）
      eventBus.$on('freeze-setup', this.onFreezeSetup)
      // 监听高级筛选模式进入/退出事件（页面切换工具栏到筛选专用栏）
      eventBus.$on('enter-filter-mode', () => {
        this.filterState = true
      })
      eventBus.$on('exit-filter-mode', () => {
        this.filterState = false
        this.filterHasConditions = false
      })
      // 页面筛选组件同步已保存的筛选模板：挂到当前一级菜单的二级菜单目录
      eventBus.$on('filter-templates-loaded', this.onFilterTemplatesLoaded)
      eventBus.$on('filter-conditions-changed', this.onFilterConditionsChanged)
      // 筛选模板被应用或保存成功：当前条件组合匹配该模板，工具栏显示"更改模板名/删除模板"
      eventBus.$on('template-applied', this.onTemplateApplied)
      // 当前条件组合与所有已保存模板不一致：显示"设为常用模板"
      eventBus.$on('template-mismatched', this.onTemplateMismatched)

      //--update-begin----author:liusq---date:20210223------for:关于测边菜单遮挡内容问题详细说明 #2255
      this.collapsed=!this.sidebarOpened;
      //--update-begin----author:liusq---date:20210223------for:关于测边菜单遮挡内容问题详细说明 #2255

      // 根据后台配置菜单，重新排序加载路由信息
      //console.log('----加载菜单逻辑----')
      //console.log(this.mainRouters)
      //console.log(this.permissionMenuList)
      //console.log('----navTheme------'+this.navTheme)
      //--update-end----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
    },
    mounted() {
      // 根据当前URL自动匹配侧边栏菜单，只做高亮，不跳转（F5刷新URL不变，本来就在当前页）
      this.$nextTick(() => {
        // 监听业务页实时触发喜报（挂靠平台设置所属队长等场景，本端即时广播）
        this._notifyBusHandler = (text) => this.pushNotify(text)
        eventBus.$on('push-notify', this._notifyBusHandler)
        // 轮询喜报：进页面拉一次最近 N 条，之后每 15s 增量拉取（按 id 去重，FIFO 依次播）
        this._notifySeen = new Set()
        this.pollNotify()
        this._notifyPollTimer = setInterval(() => this.pollNotify(), 15000)
        if (this.sidebarMenus && this.sidebarMenus.length > 0) {
          // 构建平铺菜单（排行组 + 全部分类目录，分类名作小标题）
          this.buildAllSubMenus()
          // 匹配当前路由，设置一级/二级选中态与面包屑
          this.matchRouteToSubMenu()
        }
      }, 50);

    },
    methods: {
      ...mapActions(['setSidebar']),
      ...mapGetters(["userInfo"]),
      // ---- 顶栏公告：单条向上轮播 + 详情弹窗 ----
      startTicker() {
        this.stopTicker()
        this.tickerTimer = setInterval(() => {
          const len = this.activeNotices.length
          if (len <= 1) return
          this.tickerMoving = true
          this.tickerIndex = (this.tickerIndex + 1) % len
        }, 3500)
      },
      stopTicker() {
        if (this.tickerTimer) {
          clearInterval(this.tickerTimer)
          this.tickerTimer = null
        }
      },
      onTickerEnter() {
        this.stopTicker()
      },
      onTickerLeave() {
        if (this.activeNotices.length >= 2) this.startTicker()
      },
      openNotice(n) {
        this.currentNotice = n
        this.noticeModalVisible = true
      },
      // 「我知道了」：标记该条已读并移出轮播
      confirmNoticeRead() {
        if (this.currentNotice) {
          const id = this.currentNotice.id
          if (this.readNoticeIds.indexOf(id) === -1) {
            this.readNoticeIds = this.readNoticeIds.concat(id)
            try {
              localStorage.setItem('pro__noticeRead', JSON.stringify(this.readNoticeIds))
            } catch (e) { /* 忽略存储异常 */ }
          }
          this.tickerIndex = 0
          this.tickerMoving = false
        }
        this.currentNotice = null
        this.noticeModalVisible = false
      },
      // 点遮罩/×：仅关闭，不标记已读
      closeNoticeModal() {
        this.currentNotice = null
        this.noticeModalVisible = false
      },
      // 喜报文案分段：高亮关键对象（队长名/平台名/成交人名），其余正常显示，末尾自动后缀时间
      // 支持两种格式："恭喜 X 增加一名 Y 队员"（队长+平台双高亮）与"恭喜 X 成交..."（单高亮）
      // 不匹配时整句普通显示（安全兜底，不引入 v-html）
      notifySegments(notify) {
        if (!notify) return []
        const hits = []
        const m1 = /^恭喜 (.+?)\s增加一名\s(.+?)\s队员/.exec(notify.text)
        if (m1) {
          hits.push({ t: m1[1], hl: true, at: notify.text.indexOf(m1[1]) })
          hits.push({ t: m1[2], hl: true, at: notify.text.indexOf(m1[2]) })
        } else {
          const m2 = /^恭喜 (.+?)\s成交/.exec(notify.text)
          if (m2) hits.push({ t: m2[1], hl: true, at: notify.text.indexOf(m2[1]) })
        }
        hits.sort((a, b) => a.at - b.at)
        // 按高亮点位置切割普通段
        const segs = []
        let cursor = 0
        for (const h of hits) {
          if (h.at > cursor) segs.push({ t: notify.text.slice(cursor, h.at), hl: false })
          segs.push({ t: h.t, hl: true })
          cursor = h.at + h.t.length
        }
        if (cursor < notify.text.length) segs.push({ t: notify.text.slice(cursor), hl: false })
        if (!segs.length) segs.push({ t: notify.text, hl: false })
        // 末尾后缀时间（MM-DD HH:mm）：轮询到的用后端记录的创建时间（喜报真实产生时刻）；
        // 本端实时触发没带时间才用当前时刻。'-'转'/'兼容 Safari 的 Date 解析
        let d = null
        if (notify.time) {
          d = new Date(String(notify.time).replace(/-/g, '/'))
          if (isNaN(d.getTime())) d = null
        }
        if (!d) d = new Date()
        const pad = (n) => String(n).padStart(2, '0')
        segs.push({ t: ' ' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()), hl: false })
        return segs
      },
      // ---- 喜报通知：横向滚动（rAF 驱动，支持 hover 暂停/继续，滚完即消失），队列空恢复公告/日期 ----
      playNotify() {
        if (this.notifyQueue.length === 0) {
          this.notifyActive = null
          return
        }
        this.notifyActive = this.notifyQueue.shift()
        // 动态测量：文字从轨道右外滚到完全滚出左缘（right=0），速度固定 90px/s
        this.$nextTick(() => {
          const rail = this.$refs.notifyRail
          const text = this.$refs.notifyText
          if (!rail || !text) return
          text.style.transition = 'none'
          this._notifyPos = rail.offsetWidth // 起点：文本左边在轨道右缘
          this._notifySpeed = 90
          this._notifyRunning = true
          this._notifyLastTs = null
          this._notifyPass = 0 // 需求：每条喜报统一滚动2遍（所有人一致）
          text.style.left = rail.offsetWidth + 'px'
          if (this._notifyRaf) cancelAnimationFrame(this._notifyRaf)
          this._notifyRaf = requestAnimationFrame(this.notifyStep)
        })
      },
      // 单帧推进：按速度移动 left，文字完全滚出（右缘=0）即结束
      notifyStep(ts) {
        const text = this.$refs.notifyText
        if (!text) return
        if (!this._notifyRunning) return // 已暂停（hover）
        if (this._notifyLastTs === null) this._notifyLastTs = ts
        const dt = Math.min((ts - this._notifyLastTs) / 1000, 0.1) // 限幅防大跳
        this._notifyLastTs = ts
        this._notifyPos -= this._notifySpeed * dt
        if (this._notifyPos <= -text.offsetWidth) {
          // 第1遍滚完：从头再滚1遍；第2遍滚完才消失
          if (!this._notifyPass) {
            this._notifyPass = 1
            const rail = this.$refs.notifyRail
            this._notifyPos = rail ? rail.offsetWidth : 0
            text.style.left = this._notifyPos + 'px'
            this._notifyRaf = requestAnimationFrame(this.notifyStep)
            return
          }
          text.style.left = -text.offsetWidth + 'px' // 贴住左缘，完全滚出
          this._notifyRunning = false
          this._notifyPos = null
          this._notifyPass = null
          this.notifyActive = null // 胶囊消失，恢复公告/日期
          this.$nextTick(() => { if (this.notifyQueue.length) this.playNotify() })
          return
        }
        text.style.left = this._notifyPos + 'px'
        this._notifyRaf = requestAnimationFrame(this.notifyStep)
      },
      // hover 暂停
      pauseNotify() {
        if (!this.notifyActive) return
        this._notifyRunning = false
        this._notifyLastTs = null
        if (this._notifyRaf) cancelAnimationFrame(this._notifyRaf)
      },
      // 离开继续滚动
      resumeNotify() {
        if (!this.notifyActive || this._notifyRunning) return
        this._notifyRunning = true
        this._notifyLastTs = null
        if (this._notifyRaf) cancelAnimationFrame(this._notifyRaf)
        this._notifyRaf = requestAnimationFrame(this.notifyStep)
      },
      // 喜报入口：pushNotify(text, id, time) —— 本端业务触发与后端轮询共用；id 用于去重，time 为喜报产生时间
      pushNotify(text, id, time) {
        const now = Date.now()
        // 文案去重：本端刚实时播过的喜报，后端轮询回来时不再重复播。
        // 窗口 90s：只盖住"本地即时播 → 15s 轮询回带"这一小段，不吞真实的连续新增
        if (this._notifyPlayedText) {
          const last = this._notifyPlayedText.get(text)
          if (last && now - last < 90 * 1000) return
        }
        this.notifyQueue.push({ id: id || now, text: text, time: time })
        if (!this._notifyPlayedText) this._notifyPlayedText = new Map()
        this._notifyPlayedText.set(text, now)
        if (!this.notifyActive) this.playNotify()
      },
      // 轮询拉取最新喜报（后端落库，最近 N 条，按 id 去重后依次播）
      // 喜报是"推给在线用户"的时效内容：首次拉取只把已存在的记录记为基线、不回放
      // （离线/登出期间产生的喜报不再补播）；之后轮询到的新增才依次播
      pollNotify() {
        getAction('/dm/dmPlatformNotify/queryList', { limit: 10 }).then((res) => {
          if (!res || !res.success || !res.result) return
          const list = Array.isArray(res.result) ? res.result : [res.result]
          const fresh = []
          list.forEach((item) => {
            if (!item || !item.id || !item.text) return
            if (this._notifySeen && this._notifySeen.has(item.id)) return
            if (!this._notifySeen) this._notifySeen = new Set()
            this._notifySeen.add(item.id)
            fresh.push(item)
          })
          if (this._notifyBaselineDone) {
            // 接口按时间倒序返回，反转为先产生的先播
            fresh.reverse().forEach((item) => this.pushNotify(item.text, item.id, item.createTime))
          }
          this._notifyBaselineDone = true
        }).catch(() => {})
      },
      // 全局搜索（当前 UI 已改为「开发中」占位，接入后端搜索接口后取消注释恢复，同时恢复 data 里的 globalSearchKeyword/searchFocused）
      // onGlobalSearch() {
      //   const keyword = (this.globalSearchKeyword || '').trim()
      //   if (!keyword) {
      //     return
      //   }
      //   console.log('全局搜索：', keyword)
      //   // TODO: 接入全局搜索接口或跳转到搜索结果页
      // },
      // 全局新增下拉：懒挂载对应抽屉并打开其原有新增表单
      // 供 provide 的 closeCurrent 使用：业务页本地抽屉保存成功后会 inject 调用它。
      // 全局新增抽屉已下线，此方法现在是安全 no-op（refs 不存在时跳过），
      // 保留 provide 是为了不让本地抽屉的 this.closeCurrent() 抛 undefined 错误。
      closeGlobalAddDrawers() {
        ['globalDriverDrawer', 'globalCarDrawer', 'globalPhoneDrawer', 'globalWorkorderDrawer', 'globalBillDrawer'].forEach(r => {
          if (this.$refs[r]) {
            this.$refs[r].visible = false
          }
        })
      },
      // 一级分类的语义化图标（24×24 描边 SVG，按分类名匹配）。
      // 独立于后台菜单的 icon 字段，避免图标名配置缺失/改名导致侧栏图标消失
      categoryIcon(title) {
        const icons = {
          '客户': [
            'M12 4.2a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8z',
            'M4.8 20.2c.5-4 3.4-6.3 7.2-6.3s6.7 2.3 7.2 6.3'
          ],
          '工单': [
            'M8 3.6h6.2l5.2 5.2v10.6a1.6 1.6 0 0 1-1.6 1.6H8a1.6 1.6 0 0 1-1.6-1.6V5.2A1.6 1.6 0 0 1 8 3.6z',
            'M14.2 3.6V8.8h5.2',
            'M9.6 13h6.4',
            'M9.6 16.6h4'
          ],
          '车辆': [
            'M4.8 15.8l1.8-5.9A2 2 0 0 1 8.5 8.5h7a2 2 0 0 1 1.9 1.4l1.8 5.9',
            'M3.8 15.8h16.4a1 1 0 0 1 1 1v2.6a1 1 0 0 1-1 1H3.8a1 1 0 0 1-1-1v-2.6a1 1 0 0 1 1-1z',
            'M7.4 18.1h.01',
            'M16.6 18.1h.01'
          ],
          '手机': [
            'M8.2 2.6h7.6A1.6 1.6 0 0 1 17.4 4.2v15.6a1.6 1.6 0 0 1-1.6 1.6H8.2a1.6 1.6 0 0 1-1.6-1.6V4.2a1.6 1.6 0 0 1 1.6-1.6z',
            'M12 17.8h.01'
          ],
          '平台': [
            'M12 2.8l9.2 4.6L12 12 2.8 7.4z',
            'M3 12.4l9 4.5 9-4.5',
            'M3 17l9 4.5 9-4.5'
          ],
          '维护': [
            'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z'
          ],
          '结算': [
            'M4 6.2h16a1.8 1.8 0 0 1 1.8 1.8v8a1.8 1.8 0 0 1-1.8 1.8H4a1.8 1.8 0 0 1-1.8-1.8V8a1.8 1.8 0 0 1 1.8-1.8z',
            'M12 9.9a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2z',
            'M6.2 12h.01',
            'M17.8 12h.01'
          ],
          '通知': [
            'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9',
            'M10.3 21a1.94 1.94 0 0 0 3.4 0'
          ],
          '设置': [
            'M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z',
            'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z'
          ]
        }
        return icons[title] || null
      },
      // 是否刷新/重新加载类按钮（hover 时图标预旋转）
      isReloadBtn(btn) {
        const icon = btn.icon || ''
        return /reload|refresh/i.test(icon) || /reload|refresh/i.test(btn.key)
      },
      // 工具栏按钮点击
      onToolbarButtonClick(btn) {
        // 排行页按钮处理
        if (this.activeMenu === 'home') {
          if (btn.key === 'refresh') {
            eventBus.$emit('rank-refresh')
          } else if (btn.key === 'resize') {
            this.resizeState = true
            this.toolbarMode = 'resize'
            this.resizeTick++
            // 通知排行页表格进入调列宽模式
            eventBus.$emit('enter-resize-mode')
          } else if (btn.key === 'sort') {
            this.resizeState = true
            this.toolbarMode = 'sort'
            this.resizeTick++
            // 通知排行页表格进入列排序模式
            eventBus.$emit('enter-sort-mode')
          }
          return
        }
        eventBus.$emit('toolbar-button-click', btn.key)
      },
      // 列宽调整保存
      onSaveResize() {
        localStorage.setItem('driverResizingMode', 'false')
        localStorage.setItem('carResizingMode', 'false')
        localStorage.setItem('jsResizingMode', 'false')
        localStorage.setItem('phoneResizingMode', 'false')
        localStorage.setItem('platformResizingMode', 'false')
        if (this.toolbarMode === 'freeze') {
          eventBus.$emit('freeze-save')
        } else if (this.toolbarMode === 'sort') {
          eventBus.$emit('sort-save')
        } else {
          eventBus.$emit('resize-save')
        }
        this.resizeMode = false
        this.resizeState = false
        this.resizeTick++
        this.$forceUpdate()
      },
      // 列宽调整取消
      onCancelResize() {
        localStorage.setItem('driverResizingMode', 'false')
        localStorage.setItem('carResizingMode', 'false')
        localStorage.setItem('jsResizingMode', 'false')
        localStorage.setItem('phoneResizingMode', 'false')
        localStorage.setItem('platformResizingMode', 'false')
        if (this.toolbarMode === 'freeze') {
          eventBus.$emit('freeze-cancel')
        } else if (this.toolbarMode === 'sort') {
          eventBus.$emit('sort-cancel')
        } else {
          eventBus.$emit('resize-cancel')
        }
        this.resizeMode = false
        this.resizeState = false
        this.resizeTick++
        this.$forceUpdate()
      },
      // 列冻结模式：接收页面上报的列数与当前冻结值，初始化下拉
      onFreezeSetup(payload) {
        if (payload && payload.max) {
          this.freezeMax = payload.max
          this.freezeSelect = payload.current || 0
        }
      },
      // 列冻结下拉变化：通知页面实时预览
      onFreezeCountChange() {
        eventBus.$emit('freeze-count', Number(this.freezeSelect))
      },
      // 高级筛选模式：点击专用工具栏的「退出筛选」，通知当前页面执行退出逻辑
      onExitFilter() {
        this.filterState = false
        this.filterHasConditions = false
        // 退出筛选时，如果当前选中的是子级模板，切回第一个父级
        if (this.activeSubMenu && this.activeSubMenu.startsWith('filter-tpl-')) {
          const parents = this.subMenus.filter(m => !m.isFilterTemplate && !m.isGroup)
          if (parents.length > 0) {
            this.activeSubMenu = parents[0].key
            localStorage.setItem('activeSubMenu_' + this.activeMenu, parents[0].key)
          }
        }
        this.currentMatchedTemplate = null
        eventBus.$emit('filter-exit')
      },
      // 高级筛选模式：专用工具栏「重新加载」，复用当前页 case 'refresh' 逻辑（保留筛选+分页重载）
      onFilterReload() {
        this.filterReloadLoading = true
        eventBus.$emit('toolbar-button-click', 'refresh')
        setTimeout(() => {
          this.filterReloadLoading = false
        }, 1000)
      },
      // 高级筛选模式：「导出」按钮，复用当前页导出逻辑
      onFilterExport() {
        eventBus.$emit('toolbar-button-click', 'export')
      },
      // 高级筛选模式：「设为常用模板」，通知当前页面打开命名弹窗保存当前筛选条件
      onFilterSaveTemplate() {
        this.savingNewTemplate = true // 标记：接下来要保存新模板了，收到新列表后自动选中最后一个
        eventBus.$emit('filter-save-template')
      },
      // 「更改模板名」：通知当前页面打开重命名弹窗
      onRenameTemplate() {
        eventBus.$emit('filter-rename-template', this.currentMatchedTemplate)
      },
      // 「删除模板」：通知当前页面删除当前模板
      onDeleteTemplate() {
        eventBus.$emit('filter-delete-template', this.currentMatchedTemplate)
      },
      // 角标刷新入口（5s 防抖：事件驱动/定时/可见性/切目录都可能触发，合并请求避免频繁打接口）
      refreshStatistics() {
        const now = Date.now()
        if (now - (this._lastStatsRefreshTime || 0) < 5000) return
        this._lastStatsRefreshTime = now
        this.loadStatistics()
      },
      // 获取统计数据（二级菜单角标）
      loadStatistics() {
        getAction('/api/statisticsApi/getStatistics').then(res => {
          if (res.success) {
            this.statistics = {
              workderNum: res.result.workderNum || 0,
              workderHoldNum: res.result.workderHoldNum || 0,
              driverAddNum: 0,
              driverUpdateNum: 0,
              carAddNum: 0,
              carUpdateNum: 0,
              carInformationNum: res.result.carInformationNum || 0,
              jsNum: res.result.jsNum || 0,
              noticeNum: res.result.noticeNum || 0
            }
            // 更新当前二级菜单的角标
            this.updateSubMenuBadges()
          }
        })
        // 客户模块「今日新增/今日更新」角标：todayAdd/todayUpdate 与客户列表
        // "今日新增/今日更新"页(searchType=2/3)完全同口径（我创建/共享给我的今天数据）；
        // 不用 todayAddPlatform——那是全平台口径，数字对不上列表页
        getAction('/dm/dmDriver/getTodayData').then(res => {
          if (res.success && res.result) {
            this.statistics.driverAddNum = res.result.todayAdd || 0
            this.statistics.driverUpdateNum = res.result.todayUpdate || 0
            this.updateSubMenuBadges()
          }
        })
        // 车辆模块「今日新增/今日更新」角标：todayAddCar/todayUpdateCar 与车辆列表
        // "今日新增/今日更新"页(searchType=2/3)完全同口径，不用平台口径字段
        getAction('/dm/dmCar/getCarData').then(res => {
          if (res.success && res.result) {
            this.statistics.carAddNum = res.result.todayAddCar || 0
            this.statistics.carUpdateNum = res.result.todayUpdateCar || 0
            this.updateSubMenuBadges()
          }
        })
      },
      // 更新二级菜单角标（平铺结构：按每个目录所属分类映射）
      updateSubMenuBadges() {
        if (!this.subMenus || !this.subMenus.length) return
        this.subMenus = this.subMenus.map(item => {
          if (item.isGroup) return item
          const bm = SUB_BADGE_MAP[item.parentTitle] || {}
          const btm = SUB_BADGE_TYPE_MAP[item.parentTitle] || {}
          return {
            ...item,
            badge: this.statistics[bm[item.title]] || 0,
            badgeType: btm[item.title] || 'red-bg'
          }
        })
      },
      // 首页点击：滚动定位到排行分组 + 图标栏选中首页（排行目录已平铺，无需切换菜单数据）
      onHomeClick() {
        this.menuFocusKey = 'home'
        this.scrollToGroup('group-home')
        // 排行页工具栏：仅重新加载
        this.toolbarButtons = [
          { key: 'refresh', title: '重新加载', icon: 'icon-shuaxin' }
        ]
        // 路由跳转到排行页
        if (this.$route.path !== '/dashboard/analysis') {
          this.$router.push('/dashboard/analysis')
        }
      },
      // 构建平铺二级菜单：排行组 + 所有业务分类目录（分类名作小标题）
      buildAllSubMenus() {
        const devPaths = ['/dm/phone/revail', '/dm/phone/callTask', '/dm/platform/task']
        const list = []
        let rankInserted = false
        // 排行组（首页）：目录点击后跳排行页并切换对应榜单；位置在"结算"分类之后
        const hasJsMenu = (this.sidebarMenus || []).some(m => m.title === '结算')
        this._hasJsMenu = hasJsMenu
        const insertRankGroup = () => {
          if (rankInserted) return
          rankInserted = true
          list.push({ key: 'group-home', isGroup: true, title: '排行' })
          ;[
            { key: 'rank-new', title: '当日新建工单排行' },
            { key: 'rank-wait', title: '当日待处理工单排行' },
            { key: 'rank-hold', title: '当日挂起中工单排行' },
            { key: 'rank-customer', title: '本月账号开通数量' }
          ].forEach(r => {
            list.push({
              key: r.key,
              title: r.title,
              path: '/dashboard/analysis',
              parentKey: 'home',
              parentTitle: '排行',
              groupKey: 'group-home',
              isRank: true
            })
          })
        }
        // 业务分类目录（平铺所有一级菜单的 children）
        ;(this.sidebarMenus || []).forEach(menu => {
          if (!menu.children || !menu.children.length) return
          list.push({ key: 'group-' + menu.key, isGroup: true, title: menu.title })
          const bm = SUB_BADGE_MAP[menu.title] || {}
          const btm = SUB_BADGE_TYPE_MAP[menu.title] || {}
          menu.children
            .filter(child => child.meta && !child.hidden)
            .forEach(child => {
              const childPath = child.path || child.url || ''
              list.push({
                key: child.name || child.id,
                title: child.meta.title,
                path: childPath,
                parentKey: menu.key,
                parentTitle: menu.title,
                groupKey: 'group-' + menu.key,
                badge: this.statistics[bm[child.meta.title]] || 0,
                badgeType: btm[child.meta.title] || 'red-bg',
                isDev: devPaths.includes(childPath)
              })
            })
          // 排行组插在"结算"分类之后；无结算分类时退到"平台"之后（再兜底末尾追加）
          const isJsMenu = menu.title === '结算'
          const isPlatformMenu = menu.title === '平台' || (menu.key && menu.key.toLowerCase().indexOf('platform') >= 0)
          if (isJsMenu || (!this._hasJsMenu && isPlatformMenu)) insertRankGroup()
        })
        // 兜底：没找到"平台"分类时排行组追加到末尾
        if (!rankInserted) insertRankGroup()
        this.subMenus = list
      },
      // 滚动定位到某个分类小标题
      scrollToGroup(groupKey) {
        const el = document.getElementById('menu-group-' + groupKey)
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      },
      // 二级菜单滚动联动：图标栏高亮跟随当前滚到顶部的分类
      onMenuScroll(e) {
        const container = e && e.target
        if (!container) return
        const groups = container.querySelectorAll('.menu-group-title')
        if (!groups.length) return
        // 找到视口顶部（40px 缓冲）之下的最后一个分组 = 当前所在分类
        const viewTop = container.scrollTop + 40
        let currentKey = ''
        groups.forEach(g => {
          if (g.offsetTop <= viewTop) currentKey = g.getAttribute('data-group-key') || ''
        })
        if (!currentKey) return
        const levelKey = currentKey.indexOf('group-') === 0 ? currentKey.slice(6) : currentKey
        if (levelKey && this.menuFocusKey !== levelKey) {
          this.menuFocusKey = levelKey
        }
      },
      // 匹配当前路由到平铺目录：设置一级/二级选中态与面包屑
      matchRouteToSubMenu() {
        this.menuFocusKey = ''
        const currentPath = this.$route.path
        // 首页欢迎页：面包屑固定"嘀盟CRM / 首页"，不选中任何分类/目录，清空业务页残留的工具栏
        if (currentPath === '/home') {
          this.activeMenu = ''
          this.activeSubMenu = ''
          this.subTitle = '嘀盟CRM'
          this.subMenuTitle = '首页'
          this.toolbarButtons = []
          return
        }
        if (currentPath === '/dashboard/rank' || currentPath === '/dashboard/analysis' || currentPath === '/') {
          this.activeMenu = 'home'
          this.subTitle = '排行'
          const rankKey = localStorage.getItem('rankActiveSubMenu') || 'rank-new'
          this.activeSubMenu = rankKey
          const rankItem = (this.subMenus || []).find(m => m.isRank && m.key === rankKey)
          this.subMenuTitle = rankItem ? rankItem.title : ''
          return
        }
        const matched = (this.subMenus || []).find(m => !m.isGroup && m.path && currentPath.startsWith(m.path))
        if (matched) {
          this.activeMenu = matched.parentKey || 'home'
          this.subTitle = matched.parentTitle || matched.title
          this.activeSubMenu = matched.key
          this.subMenuTitle = matched.title
        }
      },
      // 页面筛选组件把「我的保存」模板同步过来：缓存到当前一级菜单下
      onFilterTemplatesLoaded(payload) {
        if (!payload || !payload.list) return
        this.$set(this.filterTemplates, this.activeMenu, payload.list)
        // 同时缓存到localStorage，下次刷新马上显示
        localStorage.setItem('filterTemplates_' + this.activeMenu, JSON.stringify(payload.list))
        this.applyFilterTemplatesToSubMenus()
        // 如果是刚保存的新模板，自动选中最后一个，作为当前匹配模板
        if (this.savingNewTemplate && this.subMenus.length > 0) {
          const templates = this.subMenus.filter(m => m.isFilterTemplate)
          if (templates.length > 0) {
            const lastTpl = templates[templates.length - 1]
            this.activeSubMenu = lastTpl.key
            localStorage.setItem('activeSubMenu_' + this.activeMenu, lastTpl.key)
            this.currentMatchedTemplate = lastTpl.template
          }
          this.savingNewTemplate = false
        }
      },
      // 页面筛选条件变化，不再匹配当前模板：释放选中态
      onFilterConditionsChanged() {
        // 如果当前选中的是子级模板，且条件变了，就释放选中态，回到第一个父级
        if (this.activeSubMenu && this.activeSubMenu.startsWith('filter-tpl-')) {
          const parents = this.subMenus.filter(m => !m.isFilterTemplate && !m.isGroup)
          if (parents.length > 0) {
            this.activeSubMenu = parents[0].key
            localStorage.setItem('activeSubMenu_' + this.activeMenu, parents[0].key)
          }
        }
        this.currentMatchedTemplate = null
      },
      // 筛选模板被应用或保存成功：当前条件组合匹配该模板（工具栏显示"更改模板名/删除模板"）
      onTemplateApplied(tpl) {
        if (tpl && tpl.title) {
          this.currentMatchedTemplate = tpl
          this.filterHasConditions = true
        }
      },
      // 当前条件组合与所有已保存模板不一致：显示"设为常用模板"
      onTemplateMismatched() {
        this.currentMatchedTemplate = null
      },
      // 把当前一级菜单下已保存的筛选模板插入到对应父级后面
      applyFilterTemplatesToSubMenus() {
        // 临时注释掉子级模板功能，用户先手动点高级筛选
        // const list = this.filterTemplates[this.activeMenu] || []
        // // 先过滤掉已有的模板
        // const parents = this.subMenus.filter(m => !m.isFilterTemplate)
        // // 把模板插入到第一个父级后面（后续再细化归属逻辑）
        // const result = []
        // parents.forEach((p, idx) => {
        //   result.push(p)
        //   // 第一个父级后面插入所有模板（临时方案）
        //   if (idx === 0) {
        //     list.forEach(tpl => {
        //       result.push({
        //         key: 'filter-tpl-' + (tpl.id || tpl.title),
        //         title: tpl.title,
        //         isFilterTemplate: true,
        //         template: tpl,
        //         badge: 0
        //       })
        //     })
        //   }
        // })
        // this.subMenus = result
        // 临时注释掉子级模板功能，直接用原来的父级菜单
      },
      // 一级图标点击：LOGO 跳首页欢迎页（面包屑"嘀盟CRM / 首页"）；home 走排行；其余走分类定位
      onIconClick(item) {
        if (item.key === 'logo') {
          // 直接设置面包屑（若已在 /home 则路由不变化也能立即生效）
          this.subTitle = '嘀盟CRM'
          this.subMenuTitle = '首页'
          if (this.$route.path === '/home') {
            // 已在首页：滚回顶部作为点击反馈
            const w = document.querySelector('.welcome-page')
            if (w) w.scrollTop = 0
          } else {
            this.$router.push('/home').catch(() => {})
          }
        } else if (item.key === 'home') {
          this.onHomeClick()
        } else {
          this.onMenuSelect(item)
        }
      },
      // 一级菜单点击：滚动定位到对应分类小标题 + 图标栏选中该分类（不影响内容区 activeMenu）
      onMenuSelect(item) {
        this.menuFocusKey = item.key
        // 点击一级分类图标：滚动二级菜单到该分类小标题
        this.scrollToGroup('group-' + item.key)
        // 存到localStorage，下次刷新也能记住
        localStorage.setItem('LAST_MENU_TITLE', item.title)
      },
      // 二级菜单点击：分类小标题滚动定位；业务目录跳 URL；排行目录切榜单
      onSubMenuSelect(item) {
        // 分类小标题：滚动定位到自身所在分组
        if (item.isGroup) {
          this.scrollToGroup(item.key)
          return
        }
        // 切换二级菜单时退出调列宽模式，新页面默认常态
        localStorage.setItem('driverResizingMode', 'false')
        localStorage.setItem('carResizingMode', 'false')
        localStorage.setItem('jsResizingMode', 'false')
        localStorage.setItem('phoneResizingMode', 'false')
        localStorage.setItem('platformResizingMode', 'false')
        this.resizeState = false
        this.filterState = false
        this.filterHasConditions = false
        this.toolbarMode = 'resize'
        this.resizeTick++
        this.activeSubMenu = item.key
        this.activeMenu = item.parentKey || 'home'
        this.subTitle = item.parentTitle || item.title
        this.subMenuTitle = item.title
        // 点击目录后：图标栏高亮交给 activeMenu（页面实际所在分类），清除滚动/点击聚焦态
        this.menuFocusKey = ''
        // 排行目录：切榜单 + 跳排行页
        if (item.isRank) {
          this.toolbarButtons = [
            { key: 'refresh', title: '重新加载', icon: 'icon-shuaxin' }
          ]
          localStorage.setItem('rankActiveSubMenu', item.key)
          if (this.$route.path !== '/dashboard/analysis') {
            this.$router.push('/dashboard/analysis')
          }
          return
        }
        // 保存该一级菜单的二级菜单状态到localStorage
        localStorage.setItem('activeSubMenu_' + (item.parentKey || ''), item.key)
        // 开发中目录：撤掉跳转，只保留选中态和「开发中」胶囊
        if (item.isDev) {
          return
        }
        // 已保存的筛选模板：不下钻路由，直接把模板条件套用到当前页（保持筛选工具栏可见）
        if (item.isFilterTemplate) {
          this.filterState = true
          this.filterHasConditions = true // 模板本身带筛选条件，所以filterHasConditions是true
          this.currentMatchedTemplate = item.template // 记录当前匹配的模板
          eventBus.$emit('apply-filter-template', item.template)
          return
        }
        // 根据二级菜单名称设置不同的过滤参数
        const queryMap = {
          '全部客户': { searchType: 4 },
          '今日新增': { searchType: 2 },
          '今日更新': { searchType: 3 }
        }
        const query = queryMap[item.title] || {}
        // 跳转路由前刷新一次角标统计（切换目录感知实时）
        this.refreshStatistics()
        // 跳转路由，带上过滤参数
        if (item.path) {
          this.$router.push({ path: item.path, query: query })
        }
      },
      // 删除筛选模板
      onDeleteFilterTemplate(item) {
        if (!item || !item.template) return
        const list = this.filterTemplates[this.activeMenu] || []
        // 找到要删除的模板索引
        const idx = list.findIndex(t => (t.id || t.title) === (item.template.id || item.template.title))
        if (idx > -1) {
          list.splice(idx, 1)
          this.$set(this.filterTemplates, this.activeMenu, [...list])
          // 通知页面删除对应的模板
          eventBus.$emit('delete-filter-template', item.template)
          // 重新渲染二级菜单
          this.applyFilterTemplatesToSubMenus()
        }
      },
      toggle() {
        this.collapsed = !this.collapsed
        this.setSidebar(!this.collapsed)
        triggerWindowResizeEvent()
      },
      menuSelect() {
        if (!this.isDesktop()) {
          this.collapsed = false
        }
      },
      //update-begin-author:taoyan date:20190430 for:动态路由title显示配置的菜单title而不是其对应路由的title
      myMenuSelect(value){
        //此处触发动态路由被点击事件
        this.findMenuBykey(this.menus,value.key)
        this.$emit("dynamicRouterShow",value.key,this.activeMenu.meta.title)
        // update-begin-author:sunjianlei date:20191223 for: 修复刷新后菜单Tab名字显示异常
        let storeKey = 'route:title:' + this.activeMenu.path
        this.$ls.set(storeKey, this.activeMenu.meta.title)
        // update-end-author:sunjianlei date:20191223 for: 修复刷新后菜单Tab名字显示异常
      },
      findMenuBykey(menus,key){
        for(let i of menus){
          if(i.path==key){
            this.activeMenu = {...i}
          }else if(i.children && i.children.length>0){
            this.findMenuBykey(i.children,key)
          }
        }
      }
      //update-end-author:taoyan date:20190430 for:动态路由title显示配置的菜单title而不是其对应路由的title
    }
  }

</script>

<style lang="less">
  // ===== 顶栏公告：单条向上轮播 + 详情弹窗 =====
  .dm-notice-viewport {
    flex: 1;
    overflow: hidden;
    height: 20px;
    cursor: pointer;
    position: relative;
  }
  .dm-notice-track {
    display: flex;
    flex-direction: column;
    will-change: transform;
  }
  .dm-notice-line {
    height: 20px;
    line-height: 20px;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    font-size: 13px;
    color: #666;
    overflow: hidden;
  }
  .dm-notice-tag {
    flex-shrink: 0;
    font-size: 11px;
    line-height: 16px;
    padding: 0 6px;
    color: #fff;
    background: #faad14;
    border-radius: 8px;
  }
  // 日期标签：与 NEW 区分，蓝色低调样式
  .dm-notice-tag-date {
    background: #1890ff;
  }
  // ===== 喜报通知：横向滚动胶囊 =====
  .dm-notify {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    height: 32px;
    padding: 0 14px;
    border-radius: 16px;
    background: #fffbe6;
    overflow: hidden;
  }
  .dm-notify-rail {
    position: relative;
    flex: 1;
    overflow: hidden;
    height: 20px;
  }
  .dm-notify-text {
    position: absolute;
    left: 100%;
    top: 0;
    white-space: nowrap;
    font-size: 13px;
    color: #333;
    line-height: 20px;
    will-change: left;
  }
  .dm-notice-title {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dm-notice-mask {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dm-notice-modal {
    background: #fff;
    border-radius: 8px;
    width: 440px;
    max-width: calc(100vw - 32px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }
  .dm-notice-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px 12px;
    border-bottom: 1px solid #f0f0f0;
  }
  .dm-notice-modal-title {
    font-size: 15px;
    font-weight: 600;
    color: #262626;
  }
  .dm-notice-modal-close {
    width: 24px;
    height: 24px;
    border: none;
    background: none;
    cursor: pointer;
    color: #8c8c8c;
    font-size: 16px;
    border-radius: 4px;
    line-height: 1;
  }
  .dm-notice-modal-close:hover {
    background: #f5f5f5;
    color: #262626;
  }
  .dm-notice-modal-body {
    padding: 16px 20px;
    font-size: 13px;
    color: #595959;
    line-height: 1.7;
  }
  .dm-notice-modal-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }
  .dm-notice-modal-type {
    font-size: 11px;
    line-height: 16px;
    padding: 0 6px;
    border-radius: 3px;
  }
  .dm-notice-modal-type.new {
    color: #1890ff;
    background: #e6f7ff;
  }
  .dm-notice-modal-type.opt {
    color: #52c41a;
    background: #f6ffed;
  }
  .dm-notice-modal-date {
    font-size: 12px;
    color: #8c8c8c;
  }
  .dm-notice-modal-footer {
    padding: 12px 20px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    justify-content: flex-end;
  }
  .dm-notice-modal-btn {
    height: 32px;
    padding: 0 20px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    background: #1890ff;
    color: #fff;
    font-size: 14px;
  }
  .dm-notice-modal-btn:hover {
    background: #40a9ff;
  }

  // ===== 工具栏按钮统一样式（含 hover 美化）=====
  .dm-tb-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 0 12px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 32px;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }
  .dm-tb-btn svg {
    transition: transform 0.2s ease;
  }
  .dm-tb-btn-default {
    color: #666;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
  .dm-tb-btn-default:hover {
    color: #1890ff;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.14);
    transform: scale(1.03);
  }
  .dm-tb-btn-primary {
    color: #fff;
    background: #1890ff;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.25);
  }
  .dm-tb-btn-primary:hover {
    background: #40a9ff;
    box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
    transform: scale(1.03);
  }
  .dm-tb-btn-danger {
    color: #ff4d4f;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
  .dm-tb-btn-danger:hover {
    background: #fff1f0;
    box-shadow: 0 6px 16px rgba(255, 77, 79, 0.18);
    transform: scale(1.03);
  }
  .dm-tb-btn-active {
    color: #1890ff !important;
    background: #e6f7ff !important;
    box-shadow: 0 0 0 1px #1890ff inset !important;
  }
  .dm-tb-btn-disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
  .dm-tb-btn-wide {
    padding: 0 16px;
  }
  // 刷新/重新加载类按钮：hover 时图标预旋转
  .dm-tb-btn-reload:hover svg {
    transform: rotate(-90deg);
  }
  // 刷新按钮加载动效
  .btn-loading i {
    animation: spin 1s linear infinite;
    display: inline-block;
  }
  .btn-loading svg {
    animation: spin 1s linear infinite;
    display: inline-block;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(-360deg); }
  }

  // 呼吸效果小圆点
  .badge-dot {
    position: absolute;
    top: 10px;
    right: 14px;
    width: 8px;
    height: 8px;
    background: #ff4d4f;
    border-radius: 50%;
    animation: breathe 1.5s ease-in-out infinite;
  }

  @keyframes breathe {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.5;
      transform: scale(1.2);
    }
  }

  // 顶部一级菜单项样式
  .top-menu-item {
    padding: 6px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    transition: all 0.2s;

    &:hover {
      background: #f5f7fa;
      color: #1890ff;
    }

    &.active {
      background: #e6f7ff;
      color: #1890ff;
      font-weight: 500;
    }
  }

  body {
    // 打开滚动条固定显示
    overflow-y: auto;

    &.colorWeak {
      filter: invert(80%);
    }
  }

  .layout {
    min-height: 100vh !important;
    overflow-x: hidden;

    &.mobile {

      .ant-layout-content {

        .content {
          margin: 24px 0 0;
        }
      }

      /**
       * ant-table-wrapper
       * 覆盖的表格手机模式样式，如果想修改在手机上表格最低宽度，可以在这里改动
       */
      .ant-table-wrapper {
        .ant-table-content {
          overflow-y: auto;
        }
        .ant-table-body {
          min-width: 800px;
        }
      }
      .sidemenu {
        .ant-header-fixedHeader {

          &.ant-header-side-opened, &.ant-header-side-closed {
            width: 100%
          }
        }
      }

      .topmenu {
        /* 必须为 topmenu  才能启用流式布局 */
        &.content-width-Fluid {
          .header-index-wide {
            margin-left: 0;
          }
        }
      }
      .header, .top-nav-header-index {
        .user-wrapper .action {
          padding: 0 12px;
        }
      }
    }

    &.ant-layout-has-sider {
      flex-direction: row;
    }

    .trigger {
      font-size: 22px;
      line-height: 42px;
      padding: 0 18px;
      cursor: pointer;
      transition: color 300ms, background 300ms;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    .topmenu {
      .ant-header-fixedHeader {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9;
        width: 100%;
        transition: width .2s;

        &.ant-header-side-opened {
          width: 100%;
        }

        &.ant-header-side-closed {
          width: 100%;
        }
      }
      /* 必须为 topmenu  才能启用流式布局 */
      &.content-width-Fluid {
        .header-index-wide {
          max-width: unset;
          margin-left: 24px;
        }

        .page-header-index-wide {
          max-width: unset;
        }
      }

    }

    .sidemenu {
      .ant-header-fixedHeader {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9;
        width: 100%;
        transition: width .2s;

        &.ant-header-side-opened {
          width: calc(100% - 90px)
        }

        &.ant-header-side-closed {
          width: calc(100% - 80px)
        }
      }
    }

    .header {
      height: 64px;
      padding: 0 12px 0 0;
      background: #fff;
      /*box-shadow: 0 1px 4px rgba(0, 21, 41, .08);*/
      position: relative;
    }

    .header, .top-nav-header-index {

      .user-wrapper {
        float: right;
        height: 100%;

        .action {
          cursor: pointer;
          padding: 0 14px;
          display: inline-block;
          transition: all .3s;

          height: 70%;
          line-height: 46px;

          &.action-full {
            height: 100%;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.3);
          }

          .avatar {
            margin: 20px 10px 20px 0;
            color: #1890ff;
            background: hsla(0, 0%, 100%, .85);
            vertical-align: middle;
          }

          .icon {
            font-size: 16px;
            padding: 4px;
          }

          .anticon {
            color: inherit;
          }
        }
      }

      &.dark {
        .user-wrapper {

          .action {
            color: black;

            &:hover {
             // background: rgba(0, 0, 0, 0.05);
            }

            .anticon {
              color: inherit;
            }
          }
        }
      }
    }

    &.mobile {
      .top-nav-header-index {

        .header-index-wide {

          .header-index-left {

            .trigger {
              color: rgba(255, 255, 255, 0.85);
              padding: 0 12px;
            }

            .logo.top-nav-header {
              text-align: center;
              width: 56px;
              line-height: 58px;
            }
          }
        }

        .user-wrapper .action .avatar {
          margin: 20px 0;
        }

        &.light {

          .header-index-wide {

            .header-index-left {
              .trigger {
                color: rgba(0, 0, 0, 0.65);
              }
            }
          }
          //
        }
      }
    }

    &.tablet {
      // overflow: hidden; text-overflow:ellipsis; white-space: nowrap;
      .top-nav-header-index {

        .header-index-wide {

          .header-index-left {
            .logo > a {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }

    }

    .top-nav-header-index {
      box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
      position: relative;
      transition: background .3s, width .2s;

      .header-index-wide {
        width: 100%;
        margin: auto;
        padding: 0 20px 0 0;
        display: flex;
        height: 46px;

        .ant-menu.ant-menu-horizontal {
          border: none;
          height: 64px;
          line-height: 64px;
        }

        .header-index-left {
          flex: 1 1;
          display: flex;

          .logo.top-nav-header {
            width: 165px;
            height: 64px;
            position: relative;
            line-height: 64px;
            transition: all .3s;
            overflow: hidden;

            img {
              display: inline-block;
              vertical-align: middle;
              height: 32px;
            }

            h1 {
              color: #fff;
              display: inline-block;
              vertical-align: top;
              font-size: 16px;
              margin: 0 0 0 12px;
              font-weight: 400;
            }
          }
        }

        .header-index-right {
          float: right;
          height: 46px;
          overflow: hidden;
          .action:hover {
           // background-color: rgba(0, 0, 0, 0.05);
          }
        }
      }

      &.light {
        background-color: #fff;

        .header-index-wide {
          .header-index-left {
            .logo {
              h1 {
                color: #002140;
              }
            }
          }
        }
      }

      &.dark {

        .user-wrapper {

          .action {
            color: white;

            &:hover {
              background: rgba(255, 255, 255, 0.3);
            }
          }
        }
        .header-index-wide .header-index-left .trigger:hover {
          background: rgba(255, 255, 255, 0.3);
        }
      }

    }

    // 内容区
    .layout-content {
      margin: 24px 24px 0px;
      height: 64px;
      padding: 0 12px 0 0;
    }

  }

  .topmenu {
    .page-header-index-wide {
      margin: 0 auto;
      width: 100%;
    }
  }

  // drawer-sider 自定义
  .ant-drawer.drawer-sider {
    .sider {
      box-shadow: none;
    }

    &.dark {
      .ant-drawer-content {
        background-color: rgb(0, 21, 41);
      }
    }
    &.light {
      box-shadow: none;
      .ant-drawer-content {
        background-color: #fff;
      }
    }

    .ant-drawer-body {
      padding: 0
    }
  }

  // 菜单样式
  .sider {
    box-shadow: 2px 116px 6px 0 rgba(0, 21, 41, .35);
    position: relative;
    z-index: 10;

    &.ant-fixed-sidemenu {
      position: fixed;
      height: 100%;
    }

    .logo {
      height: 64px;
      position: relative;
      line-height: 64px;
      padding-left: 24px;
      -webkit-transition: all .3s;
      transition: all .3s;
      background: #002140;
      overflow: hidden;

      img, h1 {
        display: inline-block;
        vertical-align: middle;
      }

      img {
        height: 32px;
      }

      h1 {
        color: #fff;
        font-size: 18px;
        margin: 0 0 0 8px;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 600;
      }
    }

    &.light {
      background-color: #fff;
      box-shadow: 2px 116px 8px 0 rgba(29, 35, 41, 0.05);

      .logo {
        background: #fff;
        box-shadow: 1px 1px 0 0 #e8e8e8;

        h1 {
          color: unset;
        }
      }

      .ant-menu-light {
        border-right-color: transparent;
      }
    }

  }

  // 黑白调换（手动切换：个人中心下拉菜单控制，localStorage 记忆）
  html.dm-dark {
    filter: invert(1) hue-rotate(180deg);
    // 位图豁免：logo / 头像 / 证件照二次反转恢复原色，避免失真
    img {
      filter: invert(1) hue-rotate(180deg);
    }
    // 内联 SVG 图标豁免，保持原色
    svg {
      filter: invert(1) hue-rotate(180deg);
    }
    // 主操作按钮（新建/导出等 primary/warning）豁免：深色下保持蓝底白字原色
    .dm-dark-exempt {
      filter: invert(1) hue-rotate(180deg);
    }
    // 二级菜单角标豁免：保持原背景色和数字颜色
    .menu-badge {
      filter: invert(1) hue-rotate(180deg);
    }
  }

  // 外置的样式控制
  .user-dropdown-menu-wrapper.ant-dropdown-menu {
    padding: 4px 0;

    .ant-dropdown-menu-item {
      width: 160px;
    }

    .ant-dropdown-menu-item > .anticon:first-child,
    .ant-dropdown-menu-item > a > .anticon:first-child,
    .ant-dropdown-menu-submenu-title > .anticon:first-child
    .ant-dropdown-menu-submenu-title > a > .anticon:first-child {
      min-width: 12px;
      margin-right: 8px;
    }

  }

  // 数据列表 样式
  .table-alert {
    margin-bottom: 16px;
  }

  .table-page-search-wrapper {

    .ant-form-inline {

      .ant-form-item {
        display: flex;
        margin-bottom: 24px;
        margin-right: 0;

        .ant-form-item-control-wrapper {
          flex: 1 1;
          display: inline-block;
          vertical-align: middle;
        }

        > .ant-form-item-label {
          line-height: 32px;
          padding-right: 8px;
          width: auto;
        }
        .ant-form-item-control {
          height: 40px;
          line-height: 40px;
        }
      }
    }

    .table-page-search-submitButtons {
      display: block;
      margin-bottom: 18px;
      white-space: nowrap;
    }

  }

  .content {

    .table-operator {
      margin-bottom: 18px;

      button {
        margin-right: 8px;
      }
    }
  }
  .backage-cl{
    background-color: #f4f9fd !important;
  }

  /* 内容区背景色 */
  .ant-layout-content {
    background: #ffffff !important;
  }
</style>
